import { styled } from "@material-ui/core/styles";
import { InputLabel } from "@material-ui/core";

import theme from "../../constants/theme";

export default styled(InputLabel)({
  fontWeight: "bold",
  color: "#000",
  marginTop: theme.spacing(3.5),
  marginBottom: theme.spacing(0.5),
});
